<template>
    <va-edit-layout>
        <GuaranteeClaimEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></GuaranteeClaimEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
